import { Link } from 'react-router-dom';
import { notificationApi } from '../api/endpoints.js';
import { useNotice } from '../state/NoticeContext.jsx';
import { Button, Card, Empty, Spinner, fmtDateTime, useAsync } from '../ui.jsx';

export default function Notifications() {
  const notice = useNotice();
  const { data, loading, error, reload } = useAsync(() => notificationApi.list(), []);

  const markAll = async () => {
    try {
      const result = await notificationApi.markRead({ all: true });
      notice.success(result.message);
      reload();
    } catch (err) {
      notice.fromError(err);
    }
  };

  const markOne = async (id) => {
    try {
      await notificationApi.markRead({ id });
      reload();
    } catch (err) {
      notice.fromError(err);
    }
  };

  if (loading) return <Spinner label="Loading notifications" />;
  if (error) return <div className="note">We could not load your notifications. Please try again.</div>;

  const notifications = data?.notifications || [];
  const unread = data?.unreadCount || 0;

  return (
    <>
      <div className="row sp">
        <h2 style={{ margin: 0 }}>Notifications</h2>
        {unread ? (
          <Button size="sm" variant="s" onClick={markAll}>
            Mark all as read ({unread})
          </Button>
        ) : null}
      </div>

      {notifications.length === 0 ? (
        <Empty title="Nothing yet">
          Application updates, offers and reminders from schools appear here.
        </Empty>
      ) : (
        notifications.map((item) => (
          <Card
            key={item.id}
            style={item.read ? undefined : { borderColor: 'var(--g)' }}
          >
            <div className="row sp" style={{ alignItems: 'flex-start' }}>
              <div style={{ flex: 1, minWidth: 0 }}>
                <b>{item.title}</b>
                <div className="mu">{item.body}</div>
                <div className="mu" style={{ marginTop: 4 }}>
                  {fmtDateTime(item.createdAt)}
                  {item.emailed ? ' · also emailed' : ''}
                </div>
              </div>
              <div className="row" style={{ flexWrap: 'nowrap' }}>
                {item.link ? (
                  <Link to={item.link} className="btn sm" style={{ textDecoration: 'none' }}>Open</Link>
                ) : null}
                {!item.read ? (
                  <Button size="sm" variant="s" onClick={() => markOne(item.id)}>Mark read</Button>
                ) : null}
              </div>
            </div>
          </Card>
        ))
      )}
    </>
  );
}
